import { useState } from "react";
import T from "../theme";
import { SOCIAL_CHANNELS } from "../data";
import Reveal from "../components/Reveal";
import { Section, SectionLabel } from "../components/Section";

export default function SocialSection() {
  const [hov, setHov] = useState(null);
  return (
    <Section id="social" style={{ background: T.bg1 }}>
      <div className="section-pad" style={{ maxWidth: 1100, margin: "0 auto" }}>
        <Reveal><SectionLabel text="Social Media" /></Reveal>
        <Reveal delay={0.05}>
          <h2 style={{ color: T.white, fontSize: "clamp(28px,4vw,52px)", fontWeight: 900, margin: "0 0 48px", letterSpacing: -1 }}>
            Follow &amp; Share
          </h2>
        </Reveal>

        <div className="grid-social">
          {SOCIAL_CHANNELS.map((s, i) => (
            <Reveal key={i} delay={i * 0.06}>
              <div
                onMouseEnter={() => setHov(i)} onMouseLeave={() => setHov(null)}
                style={{
                  background: hov === i ? "rgba(7,20,55,0.9)" : T.bgCard,
                  border: `1px solid ${hov === i ? s.color : T.borderDim}`,
                  borderRadius: 8, padding: "28px 24px", cursor: "default",
                  transition: "all 0.25s",
                  boxShadow: hov === i ? `0 0 24px ${s.color}22` : "none",
                }}
              >
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 16 }}>
                  <span style={{ fontFamily: T.mono, fontSize: 10, color: T.blue, letterSpacing: 2 }}>#{s.id}</span>
                  <div style={{
                    background: `${s.color}18`, border: `1px solid ${s.color}40`,
                    borderRadius: 3, padding: "3px 8px",
                    fontFamily: T.mono, fontSize: 9, color: s.color, letterSpacing: 1,
                  }}>{s.cat}</div>
                </div>
                <div style={{ color: T.white, fontWeight: 800, fontSize: "clamp(16px,2vw,20px)", marginBottom: 4, letterSpacing: -0.5 }}>{s.name}</div>
                <div style={{ color: T.gray2, fontSize: 12, marginBottom: 20, fontFamily: T.mono }}>{s.handle}</div>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <div style={{ flex: 1, height: 2, background: T.bg3, borderRadius: 2 }}>
                    <div style={{ width: `${s.score}%`, height: "100%", background: s.color, borderRadius: 2, transition: "width 1s ease" }} />
                  </div>
                  <span style={{ fontFamily: T.mono, fontSize: 11, color: T.white, fontWeight: 700 }}>{s.score}K</span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </Section>
  );
}
